import {
  partNumberValidation,
  revisionValidation,
  zipFileValidation,
} from 'pu-data/Validations';

const state = {
  parameters: {
    part_number: '',
    revision: '',
    filename: '',
  },
  loadingZipFile: false,
  bundle_rfq_number: '',
  directory: {},
  errors: {},
  projectErrors: [],
  projectWarnings: [],
}

export const validateParametersRules = {
  part_number: (value) => partNumberValidation('Part Number', value),
  revision: (value) => revisionValidation('Revision', value),
  filename: (value) => zipFileValidation('Zip File', value),
}

export const aditionalRules = {
}

if(Spree.rfq_quote_number && Spree.rfq_quote_number !== '') {
  state.bundle_rfq_number = Spree.rfq_quote_number
}

if (Spree.parameters && Object.keys(Spree.parameters).length) {
  Object.assign(state.parameters, Spree.parameters)
}

export default state
